import React from "react";

const ServicesHeroBanner = ({
  subtitle,
  title,
  description,
  buttonText,
  buttonLink = "#contact",
  img,
}) => {
  return (
    <section className="hero-section d-flex align-items-center sarvish">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 hero-content">
            <span className="hero-subtitle">{subtitle}</span>
            <h1 className="hero-title">{title}</h1>
            <p>{description}</p>
            {buttonText && (
              <a href={buttonLink} className="btn btn-orange">
                {buttonText}
              </a>
            )}
          </div>

          <div className="col-lg-6 hero-image text-center mt-5 mt-lg-0">
            <img
              src={img}
              alt={title}
              className="img-fluid main-hero-img sarvish-banner"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHeroBanner;
